module.exports = __webpack_public_path__ + "img/slogan_m.9103924a.png";